import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import { useWorks } from "../contexts/WorkContext";
import "./Home.css";
import { BASEURL } from "../constants/baseUrl";
import WorkModal from "../components/WorkModal";

const Films = () => {
  const { works, fetchWorksByCategory, loading, selectWork, fetchWorkById } = useWorks();

  useEffect(() => {
    fetchWorksByCategory("film");
  }, []);

  // ✅ BLINDAGE CONTRE LA PROD
  const safeWorks = Array.isArray(works) ? works : [];

  return (
    <div>
      <Navbar />
      <main className="main">
        {loading ? (
          <p>Chargement des projets...</p>
        ) : (
          <div className="grid">
            {safeWorks.map((work) => {
              const isVideo = work.image_url?.toLowerCase().endsWith(".mp4");

              return (
                <div
                  key={work.id}
                  className="card"
                  onClick={() => {
                    selectWork(work);
                    fetchWorkById(work.id!);
                  }}
                >
                  {isVideo ? (
                    <video
                      src={`${BASEURL}${work.image_url}`}
                      className="image"
                      autoPlay
                      loop
                      muted
                      playsInline
                    />
                  ) : (
                    <img
                      src={`${BASEURL}${work.image_url}`}
                      alt={work.title}
                      className="image"
                    />
                  )}
                  <div className="overlay">
                    <h3 className="workTitle">{work.title}</h3>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <WorkModal />
      </main>
    </div>
  );
};

export default Films;
